import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  Stack,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Chip,
  Modal,
  TextField,
  DialogActions,
} from "@mui/material";
import { callUnsetApi } from "utils/api";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import "./management.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, useNavigate } from "react-router-dom";
import logUserAction from "utils/logging";
import Swal from "sweetalert2";

const Management = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [circles, setCircles] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState([]);

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/user_management");
    }
  }, [navigate]);
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    return () => {
      callUnsetApi(siteId);
    };
  }, [siteId]);
  function getRoleName(roleId) {
    const roleMapping = {
      1: "Operator",
      2: "Configuration Manager",
      3: "Admin",
      4: "Super Admin",
    };
    return roleMapping[roleId] || "Unknown Role";
  }
  useEffect(() => {
    fetchSiteData();
    const fetchCircles = async () => {
      try {
        const response = await fetch(
          "https://api.bharatnet.sunshineiotronics.com/api/v2/circles"
        );
        const data = await response.json();
        setCircles(data);
      } catch (error) {
        toast.error("Failed to fetch circles");
      }
    };
    fetchCircles();
  }, []);

  if (!userDetails || (userDetails.role !== 3 && userDetails.role !== 4)) {
    return <Navigate to="/dashboard" />;
  }
  const fetchSiteData = async () => {
    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/approval_list"
      );
      const data = await response.json();
      console.log(data);
      setUsers(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleApprove = async (email) => {
    await handleAction(email, "approve");
    logUserAction(`${email} Approved`);
  };

  const handleReject = async (email) => {
    await handleAction(email, "reject");
    logUserAction(`${email} Rejected`);
  };
  const handleOpenModal = (user) => {
    setSelectedUser(user);
    setSelectedCircles(user.circles || []);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedUser(null);
    setSelectedCircles([]);
  };

  const handleDelete = async (email) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to delete the user with email: ${email}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiUrl = `https://api.bharatnet.sunshineiotronics.com/api/v2/auth/delete?email=${email}`;
        try {
          const response = await fetch(apiUrl, {
            method: "DELETE",
          });

          if (response.ok) {
            Swal.fire("Deleted!", `${email} has been deleted.`, "success");
            logUserAction(`${email} Deleted`);
            fetchSiteData(); // Refresh table to remove the deleted user
          } else {
            Swal.fire("Error!", `Failed to delete ${email}.`, "error");
          }
        } catch (error) {
          console.error(`Error during delete:`, error);
          Swal.fire("Error!", `Error deleting ${email}.`, "error");
        }
      }
    });
  };

  const handleAction = async (email, action) => {
    const apiUrl =
      action === "approve"
        ? "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/approve"
        : "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/reject";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (response.ok) {
        if (action === "approve") {
          toast.success(`${email} successfully approved.`);
        }
        // If the action is reject, show error
        else if (action === "reject") {
          toast.error(`${email} successfully rejected.`);
        }

        fetchSiteData(); // Refresh table
      } else {
        toast.error(`Failed to ${action} ${email}.`);
      }
    } catch (error) {
      console.error(`Error during ${action}:`, error);
      toast.error(`Error during ${action} for ${email}.`);
    }
  };

  const handleBulkAction = async (action) => {
    const apiUrl =
      action === "approveAll"
        ? "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/approve_all"
        : "https://api.bharatnet.sunshineiotronics.com/api/v2/auth/reject_all";

    try {
      const response = await fetch(apiUrl, { method: "GET" });
      if (response.ok) {
        // Conditional success toast based on the action
        if (action === "approveAll") {
          toast.success("All users successfully approved.");
          logUserAction(`All users are approved`);
        } else if (action === "rejectAll") {
          toast.error("All users successfully rejected.");
          logUserAction(`All users are rejected`);
        }
        fetchSiteData(); // Refresh table
      } else {
        // Failure case for the bulk action
        toast.error(`Failed to perform bulk ${action}.`);
      }
    } catch (error) {
      console.error(`Error during bulk ${action}:`, error);
      toast.error(`Error during bulk ${action}.`);
    }
  };
  const handleSaveChanges = async () => {
    const apiUrl = `https://api.bharatnet.sunshineiotronics.com/api/v2/auth/circles`;
    const payload = {
      email: selectedUser.email,
      circles: selectedCircles,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        toast.success("Circles updated successfully.");
        logUserAction(
          `${selectedUser.email} Circles Updated to ${selectedCircles}`
        );
        fetchSiteData();
        handleCloseModal();
      } else {
        toast.error("Failed to update circles.");
      }
    } catch (error) {
      console.error("Error updating circles:", error);
      toast.error("Error updating circles.");
    }
  };

  const breadcrumbs = [
    <Link key="1" sx={{ color: "primary.main" }}>
      Home
    </Link>,
    <Typography key="3" sx={{ color: "text.primary" }}>
      User Management
    </Typography>,
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
            <br />
            {/* Action Buttons */}
            <div className="action-buttons" style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                color="success"
                sx={{ marginRight: "10px" }}
                onClick={() => handleBulkAction("approveAll")}
              >
                Approve All
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleBulkAction("rejectAll")}
              >
                Reject All
              </Button>
            </div>

            {/* Table Container */}
            <TableContainer
              component={Paper}
              elevation={3}
              sx={{
                marginTop: "30px",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <Table>
                <TableHead sx={{ backgroundColor: "rgb(250,223,186)" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Email
                    </TableCell>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Circle
                    </TableCell>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Role
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#997d3d",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" },
                        "&:hover": { backgroundColor: "#e3f2fd" },
                      }}
                    >
                      <TableCell>{user.email}</TableCell>
                      <TableCell>
                        {Array.isArray(user.circles)
                          ? user.circles.join(", ")
                          : `${user.circle}`}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={getRoleName(user.role)}
                          color={
                            user.role === 1
                              ? "success"
                              : user.role === 2
                              ? "warning"
                              : user.role === 3
                              ? "error"
                              : "info"
                          }
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell
                        sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                      >
                        {user.is_approved ? (
                          <Button
                            variant="outlined"
                            color="warning"
                            size="small"
                            startIcon={<CloseIcon />}
                            onClick={() => handleReject(user.email)}
                            sx={{ mr: 1 }}
                          >
                            Reject
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            color="success"
                            size="small"
                            startIcon={<CheckIcon />}
                            onClick={() => handleApprove(user.email)}
                            sx={{ mr: 1 }}
                          >
                            Approve
                          </Button>
                        )}
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          startIcon={<DeleteOutlinedIcon />}
                          onClick={() => handleDelete(user.email)}
                          sx={{
                            mr: 1,
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          Delete
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          startIcon={<EditOutlinedIcon />}
                          sx={{
                            mr: 1,
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                          onClick={() => handleOpenModal(user)}
                        >
                          Edit
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </div>
      </div>
      <br />

      {/* Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            outline: "none",
          }}
        >
          {selectedUser ? (
            <>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                Edit Circles
              </Typography>
              <TextField
                fullWidth
                label="Email"
                value={selectedUser.email}
                margin="normal"
                variant="outlined"
                disabled
              />

              <TextField
                fullWidth
                label="Role"
                value={getRoleName(selectedUser.role)}
                margin="normal"
                variant="outlined"
                disabled
              />
              <InputLabel
                id="circle"
                style={{ fontSize: "13px", marginLeft: "calc(2vh)" }}
              >
                Circle
              </InputLabel>
              <Select
                fullWidth
                labelId="multiple-checkbox-label"
                id="multiple-checkbox"
                multiple
                value={selectedCircles}
                input={<OutlinedInput label="Select Circles" />}
                onChange={(e) => setSelectedCircles(e.target.value)}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} sx={{ margin: 0.5 }} />
                    ))}
                  </Box>
                )}
              >
                {circles.map((circle, index) => (
                  <MenuItem key={index} value={circle.state}>
                    <Checkbox
                      checked={selectedCircles.indexOf(circle.state) > -1}
                    />
                    <ListItemText primary={circle.state} />
                  </MenuItem>
                ))}
              </Select>
              <DialogActions className="specific-button">
                <Button color="error" onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button color="success" onClick={handleSaveChanges}>
                  Save Changes
                </Button>
              </DialogActions>
            </>
          ) : (
            <Typography>Loading user details...</Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Management;
